if (!window.Eurus.loadedScript.has('header.js')) {
  window.Eurus.loadedScript.add('header.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xHeaderMenu', {
        headerObserver: null,
        isSticky: false,
        stickyCalulating: false,
        openHamburgerMenu: false,
        isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
        sectionId: '',
        stickyType: 'none',
        lastScrollTop: 0,
        themeModeChanged: false,
        scrollY: 0,
        stickyOffsetHeight: 0,
        announcementOffsetHeight: 0,
        toolbarOffsetHeight: 0,
        mobileHeaderLayout: '',
        show: null,
        subShow: new Map(),
        overlay: false,
        initIndex: new Set(),
        scrollDir: '',
        isMenuOpen: false,
        initialized: false,
        passTop: false,
        passBottom: false,
        announcementBeforeHeader: false,
        isTransparent: false,
        heightHeaderEls: [],
        stickyTimeout: null,
        compactStickyHeight: 0,
        scrollUpAnchorY: 0,
        scrollUpHideThreshold: 10,
        _scrollUpHeader: null,
        _scrollUpHeaderContainer: null,
        _scrollUpAnnouncement: null,
        reset() {
          this.headerObserver.disconnect();
          if (document.getElementById('x-header-sentinel-top')) document.getElementById('x-header-sentinel-top').remove();
          if (document.getElementById('x-header-sentinel-bottom')) document.getElementById('x-header-sentinel-bottom').remove();
          Alpine.store('xHelper').cancelEvent(`eurus:header-scroll-event`);
          this.isSticky = false;
          this.isTransparent = false;
          this.stickyCalulating = false;
          this.openHamburgerMenu = false;
          this.isTouch = ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false;
          this.sectionId = '';
          this.stickyType = 'none';
          this.lastScrollTop = 0;
          this.themeModeChanged = false;
          this.scrollY = 0;
          this.stickyOffsetHeight = 0;
          this.announcementOffsetHeight = 0;
          this.mobileHeaderLayout = '';
          this.show = null;
          this.subShow = new Map();
          this.overlay = false;
          this.initIndex = new Set();
          this.scrollDir = '';
          this.isMenuOpen = false;
          this.initialized = false;
          this.passTop = false;
          this.passBottom = false;
          this.announcementBeforeHeader = false;
          this.compactStickyHeight = 0;
          this.scrollUpAnchorY = 0;
          this._scrollUpHeader = null;
          this._scrollUpHeaderContainer = null;
          this._scrollUpAnnouncement = null;
        },
        ensurePastHeaderState(header, headerContainer, announcement) {
          if (!header.classList.contains('is-sticky')) {
            header.classList.add('is-sticky', 'is-scrolled');
            this.isSticky = true;
            this.cacheCompactStickyHeight(header);
          }
          if (!headerContainer.classList.contains('on-scroll-up-animation')) {
            const scrollPos = window.scrollY || document.documentElement.scrollTop;
            // Entering sticky hides the bar, but the CSS transition (0.4s + 0.1s delay) paints
            // it at the top first and only then slides it away — a visible pop-in that scores as
            // a layout shift. Going sticky is not an animation the user asked for, so hide it in
            // the same frame and restore the transition for genuine scroll-up reveals.
            const prevTransition = headerContainer.style.transition;
            headerContainer.style.transition = 'none';
            headerContainer.classList.add('on-scroll-up-animation');
            this.scrollUpAnchorY = scrollPos;
            if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') {
              announcement?.parentElement.classList.remove('top-header');
            }
            this.setVariableHeightHeader(false);
            this.refreshScrollUpStickyTransform(header);
            void headerContainer.offsetHeight;
            requestAnimationFrame(() => { headerContainer.style.transition = prevTransition; });
          }
        },
        showScrollUpHeader(header, headerContainer, announcement) {
          if (!header.classList.contains('is-sticky')) {
            header.classList.add('is-sticky', 'is-scrolled');
            this.isSticky = true;
            this.cacheCompactStickyHeight(header);
          }
          headerContainer.classList.remove('on-scroll-up-animation');
          this.scrollUpAnchorY = window.scrollY || document.documentElement.scrollTop;
          if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') {
            announcement?.parentElement.classList.add('top-header');
          }
          this.setVariableHeightHeader(true);
        },
        hideScrollUpHeader(header, headerContainer, announcement) {
          if (!headerContainer.classList.contains('on-scroll-up-animation')) {
            headerContainer.classList.add('on-scroll-up-animation');
            this.scrollUpAnchorY = window.scrollY || document.documentElement.scrollTop;
            if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') {
              announcement?.parentElement.classList.remove('top-header');
            }
            this.setVariableHeightHeader(false);
            this.refreshScrollUpStickyTransform(header);
          }
        },
        isWfCompactSticky(headerContainer) {
          return headerContainer?.dataset.wfCompactSticky === 'true'
            && window.matchMedia('(min-width: 1024px)').matches;
        },
        cacheCompactStickyHeight(header) {
          const stickyContent = document.getElementById('sticky-header-content');
          if (!stickyContent) return;
          requestAnimationFrame(() => {
            this.compactStickyHeight = stickyContent.offsetHeight;
            this.refreshScrollUpStickyTransform(header);
          });
        },
        debounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        },
        initSticky(headerContainer, stickyType, transparent = false) {
          setTimeout(() => {
            if (stickyType === 'none') {
              const announcement = document.getElementById("x-announcement");
              if (announcement?.dataset.isSticky === 'true') {
                this.announcementOffsetHeight = announcement?.offsetHeight;
                this.initHeaderHeightEvent();

                requestAnimationFrame(() => {
                  document.dispatchEvent(new CustomEvent("eurus:sticky-header-moved", { detail: { heightHeader: this.announcementOffsetHeight } }))
                })
              }
              return;
            }

            this.isTransparent = transparent;
            this.stickyType = stickyType;
            const header = document.getElementById(`shopify-section-${this.sectionId}`);
            const announcement = document.getElementById("x-announcement");
            const toolBar = document.getElementById('header-toolbar');
            this._scrollUpHeader = header;
            this._scrollUpHeaderContainer = headerContainer;
            this._scrollUpAnnouncement = announcement;

            if (header && announcement) {
              if (Shopify.designMode) {
                let annoucementIndex = 0, headerIndex = 0;
                headerContainer.closest('.main-container')?.querySelectorAll('.shopify-section').forEach((el, index) => {
                  if (el.classList.contains('section-announcement')) annoucementIndex = index;
                  if (el.classList.contains('section-header')) headerIndex = index;
                })
                this.announcementBeforeHeader = headerIndex > annoucementIndex;
              } else {
                this.announcementBeforeHeader = headerContainer?.dataset.sectionIndex > announcement?.dataset.sectionIndex;
              }
            }

            const sentinelTop = document.createElement('div');
            sentinelTop.id = "x-header-sentinel-top"
            const sentinelBottom = document.createElement('div');
            sentinelBottom.id = "x-header-sentinel-bottom"
            header.before(sentinelTop);
            header.after(sentinelBottom);

            this.headerObserver = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.target === header) {
                  if (!this.initialized) {
                    const rect = entry.boundingClientRect;
                    if (transparent) {
                      this.stickyOffsetHeight = document.getElementById('sticky-header-content').offsetHeight;
                    } else {
                      this.stickyOffsetHeight = rect.height;
                    }

                    if (announcement?.dataset.isSticky === 'true') {
                      if (this.announcementBeforeHeader)
                        this.announcementOffsetHeight = announcement?.offsetHeight;
                      else {
                        this.announcementOffsetHeight = 0;
                      }
                    }

                    if (toolBar?.classList.contains('js-hide-toolbar')) this.toolbarOffsetHeight = toolBar?.offsetHeight;

                    this.initVariable(header, headerContainer, stickyType, announcement);
                    this.initScrollEvent(header, headerContainer, stickyType, announcement);
                    this.initHeaderHeightEvent();

                    this.initialized = true;
                  }
                } else if (entry.target === sentinelTop) {
                  this.passTop = !entry.isIntersecting;
                } else {
                  const wasPassBottom = this.passBottom;
                  this.passBottom = !entry.isIntersecting;
                  if (
                    this.stickyType === 'on-scroll-up' &&
                    this.passBottom &&
                    !wasPassBottom &&
                    this._scrollUpHeader &&
                    this._scrollUpHeaderContainer
                  ) {
                    this.ensurePastHeaderState(
                      this._scrollUpHeader,
                      this._scrollUpHeaderContainer,
                      this._scrollUpAnnouncement
                    );
                  }
                }
              })
            })

            this.headerObserver.observe(header);
            this.headerObserver.observe(sentinelTop);
            this.headerObserver.observe(sentinelBottom);
          }, 0)
        },
        initVariable(header, headerContainer, stickyType, announcement) {
          const headerStickyTransform = 0 - this.announcementOffsetHeight - this.stickyOffsetHeight;
          const headerTopOffset = this.announcementOffsetHeight - this.toolbarOffsetHeight;
          const headerStickyHeight = this.stickyOffsetHeight - this.toolbarOffsetHeight;
          requestAnimationFrame(() => {
            header.style.setProperty('--announcement-height', headerTopOffset + "px");
            header.style.setProperty('--header-sticky-transform', `${headerStickyTransform}px`);
            // Resting height, captured before any sticky class lands. The compact-sticky CSS
            // reserves it so lifting the bar out of flow doesn't collapse the section.
            header.style.setProperty('--wf-header-reserve', `${this.stickyOffsetHeight}px`);
            if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') {
              announcement?.parentElement.style.setProperty('--header-height', `${headerStickyHeight}px`);
              announcement?.parentElement.style.setProperty('--annoucement-z', '40');
            }
            if (this.passBottom) {
              if (stickyType === 'on-scroll-up') {
                this.ensurePastHeaderState(header, headerContainer, announcement);
              } else {
                headerContainer.classList.add('is-sticky', 'is-scrolled');
                this.isSticky = true;
              } 
            }
          });
          this.handleStickyScrolling(header, headerContainer, announcement, stickyType);
        },
        initScrollEvent(header, headerContainer, stickyType, announcement) {
          let scrollDebounce = null;
          const onScroll = () => {
            clearTimeout(scrollDebounce);
            scrollDebounce = setTimeout(() => {
              let scrollPos = window.scrollY || document.documentElement.scrollTop;
              this.handleStickyScrolling(header, headerContainer, announcement, stickyType, scrollPos);
            }, 10);
          };
          const headerScrollController = new AbortController();
          Alpine.store('xHelper').eventControllers.set(`eurus:header-scroll-event`, headerScrollController);
          window.addEventListener('scroll', onScroll, { passive: true, signal: headerScrollController.signal });
        },
        handleStickyScrolling(header, headerContainer, announcement, stickyType, scrollPos) {
          if (scrollPos === undefined) {
            scrollPos = window.scrollY || document.documentElement.scrollTop;
          }
          const prevScrollY = this.scrollY;
          const scrollDelta = scrollPos - prevScrollY;
          const dir = scrollDelta > 0;
          this.scrollY = scrollPos;
          this.scrollDir = dir ? 'down' : 'up';
          requestAnimationFrame(() => {
            if (stickyType === 'always') {
              if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') announcement?.parentElement.classList.add('top-header');
              this.setVariableHeightHeader(true);
              if (this.passBottom) {
                headerContainer.classList.add('is-sticky', 'is-scrolled');
                this.isSticky = true;
              } else {
                headerContainer.classList.remove('is-sticky', 'is-scrolled');
                this.isSticky = false;
              }
            } else if (stickyType === 'reduce-logo-size') {
              if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') announcement?.parentElement.classList.add('top-header');
              this.setVariableHeightHeader(true);
              if (this.passBottom) {
                headerContainer.classList.add('reduce-logo-size', 'is-sticky', 'is-scrolled');
                this.isSticky = true;
              } else {
                headerContainer.classList.remove('reduce-logo-size', 'is-sticky', 'is-scrolled');
                this.isSticky = false;
              }
            } else {
              // is-sticky lands at passBottom. Where the sticky bar is a different height than
              // the resting header (compact-sticky), drop it at !passBottom too, so the swap
              // always happens with the resting header off-screen instead of in full view.
              const dropSticky = this.isWfCompactSticky(headerContainer) ? !this.passBottom : !this.passTop;
              if (dropSticky) {
                header.classList.remove('is-sticky', 'is-scrolled');
                headerContainer.classList.remove('on-scroll-up-animation');
                this.isSticky = false;
                this.compactStickyHeight = 0;
                this.scrollUpAnchorY = 0;
              }
              if (!this.passBottom && !dir) {
                headerContainer.style.transition = 'transform 0.1s ease-in';
                if (headerContainer.classList.contains('on-scroll-up-animation')) {
                  headerContainer.classList.remove('on-scroll-up-animation');
                  if (!this.announcementBeforeHeader && announcement?.dataset.isSticky === 'true') announcement?.parentElement.classList.add('top-header');
                  this.setVariableHeightHeader(true);
                }
                clearTimeout(this.stickyTimeout);
                this.stickyTimeout = null;
                return;
              } else {
                headerContainer.style.transition = '';
              }
              if (this.passBottom && !header.classList.contains('is-sticky')) {
                this.ensurePastHeaderState(header, headerContainer, announcement);
              }
              if (!this.scrollUpAnchorY) this.scrollUpAnchorY = scrollPos;
              const movedFromAnchor = scrollPos - this.scrollUpAnchorY;
              const isHidden = headerContainer.classList.contains('on-scroll-up-animation');
              const shouldHide = this.passBottom && scrollDelta > 0 && movedFromAnchor > this.scrollUpHideThreshold;
              const shouldShow = this.passBottom && scrollDelta < 0 && isHidden;
              if (shouldHide && !isHidden) {
                this.hideScrollUpHeader(header, headerContainer, announcement);
              } else if (shouldShow) {
                this.showScrollUpHeader(header, headerContainer, announcement);
              }
            }
          });
        },
        initHeaderHeightEvent() {
          this.heightHeaderEls = Array.from(document.querySelectorAll('[class*="--height-header"], [\\:class*="--height-header"]'));
          document.addEventListener('eurus:sticky-header-moved', (e) => {
            this.heightHeaderEls.forEach(el => {
              el.style.setProperty('--height-header', e.detail.heightHeader + "px");
            });
          })
        },
        setVariableHeightHeader(isSticky) {
          const stickyHeight = this.compactStickyHeight > 0
            ? this.compactStickyHeight
            : this.stickyOffsetHeight;
          const heightHeader = (isSticky && !Alpine.store('xMobileDock')?.showDock)
            ? this.announcementOffsetHeight + stickyHeight - this.toolbarOffsetHeight
            : this.announcementOffsetHeight;
          document.dispatchEvent(new CustomEvent("eurus:sticky-header-moved", { detail: { heightHeader: heightHeader } }))
        },
        refreshScrollUpStickyTransform(header) {
          const height = this.compactStickyHeight > 0
            ? this.compactStickyHeight
            : this.stickyOffsetHeight;
          const transform = 0 - this.announcementOffsetHeight - height;
          header.style.setProperty('--header-sticky-transform', `${transform}px`);
        },
        renderAjax(el, id, element) {
          fetch(
            `${window.location.pathname}?sections=${id}`
          ).then(response => response.json())
          .then(response => {
            let html = getSectionInnerHTML(response[id], element);
            if (el?.closest('[data-breakpoint="tablet"]')) {
              html = html?.replace('id="search-in-modal"', 'id="search-in-modal-mobile"');
            }
            el.innerHTML = html;
          }).finally(() => {
            this.heightHeaderEls.push(el);
            this.setVariableHeightHeader(true);
          });
        },
        setPosition(el, level, hamburger=false) {
          if (!hamburger) {
            level = level - 1;
          } else {
            level = level - 0.5;
          }
          requestAnimationFrame(() => {
            const elm = el.closest(".tree-menu");

            const widthEl = elm.getElementsByClassName("toggle-menu")[0];
            const widthElWitdth = widthEl.offsetWidth;
            const viewWidth = window.xViewport.innerWidth || document.documentElement.clientWidth

            const elRect = elm.getBoundingClientRect();

            const left = (elRect.left - (widthElWitdth * level)) < 100;
            const right = (elRect.right + (widthElWitdth * level)) > (viewWidth - 100);

            const isRtl = document.querySelector('body').classList.contains('rtl');

            requestAnimationFrame(() => {
              if (isRtl) {
                if (left) {
                  el.classList.add('right-0');
                  widthEl.classList.add('left-0');
                  elm.classList.remove('position-left');
                } else {
                  el.classList.add('left-0');
                  widthEl.classList.add('right-0');
                  elm.classList.add('position-left');
                }
              } else { 
                if (right) {
                  el.classList.add('left-0');
                  widthEl.classList.add('right-0');
                  elm.classList.add('position-left');
                } else {
                  el.classList.add('right-0');
                  widthEl.classList.add('left-0');
                  elm.classList.remove('position-left');
                }
              }  
            })
          })
        },
        resizeWindow(el,level, hamburger=false) {
          const onResize = this.debounce(() => {
            this.setPosition(el, level, hamburger);
          }, 100);

          addEventListener("resize", onResize);
        },
        toggleMenu(index) {
          this.initIndex.add(index);
          this.show = this.show === index ? 0 : index;
          this.overlay = (this.show !== 0);
        },
        openMenu(index, hasMenu) {
          this.initIndex.add(index);
          this.show = index;
          this.overlay = hasMenu;
        },
        closeMenu() {
          this.show = 0;
          this.overlay = false;
        },
        openSubMenu(key, index) {
          this.subShow.set(key, index);
        },
        updateHeight(el, containerId) {
          const container = document.getElementById(containerId);
          let currentAnimation = null;
          let previousHeight = null;
          
          const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
              const newHeight = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
              
              if (previousHeight !== null && Math.abs(previousHeight - newHeight) >= 1) {
                currentAnimation?.cancel();
                
                currentAnimation = container.animate([
                  { height: `${previousHeight}px` },
                  { height: `${newHeight}px` }
                ], { duration: 300, easing: 'ease-in-out' });
              }
              
              container.style.height = newHeight + 'px';
              previousHeight = newHeight;
            }
          });

          observer.observe(el);
        },
        touchItem(el, isSub = false) {
          const touchClass = isSub ? 'touched-sub' : 'touched';

          el.addEventListener("touchend", (e) => {
            if (el.classList.contains(touchClass)) {
              window.location.replace(el.getAttribute('href'));
            } else {
              e.preventDefault(); 
              var dropdown = document.getElementsByClassName(`${touchClass}`);
              for (var i = 0; i < dropdown.length; i++) { 
                dropdown[i].classList.remove(touchClass); 
              }

              el.classList.add(touchClass);
              this.selectItem(el.closest('.has-dropdown'), isSub);
            }
          });
        },
      });
    });
  });
}